export class ViewApplicationNotesConstants {
    static STEP_TITLE = "Notes";
}
